import React, { useEffect, useState } from 'react';
import { Button, Row } from 'reactstrap';

//Context
import { useAuth } from '../../../context/auth';

//API
import layoutDiarioOficial_api from '../../../api/layoutDiarioOficial_api';

//Helpers
import { showMessage } from '../../../helpers/message';

//Components
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import CadastroLayoutDiarioOficial from './components/CadastroLayoutDiarioOficial';

//Contants
import { actionsTable } from '../../../constants/MaterialTable';

function LayoutDiarioOficial() {
    //State para pegar a lista do diario oficial
    const [listDiarioOficial, setListDiarioOficial] = useState([]);

    //State para editar diário oficial
    const [layoutDiarioOficial_id, setLayoutDiarioOficial_id] = useState(null);

    //State para criar diário oficial
    const [cadastro, setCadastro] = useState(false);

    const { setLoading } = useAuth();

    //Cabeçalhos da lista de consulta infração
    const headers = [
        { value: "Identificação", objectValue: "identificacao", align: "left" }
    ];

    const editarDiarioOficial = (rowData) => {
        setLayoutDiarioOficial_id(rowData.id);
    }

    //Variavel que guarda as ações da tabela
    const actions = [actionsTable.editar(editarDiarioOficial)];

    const loadListDiarioOficial = () => {
        setLoading(true)
        layoutDiarioOficial_api.getList()
            .then(response => {
                setListDiarioOficial(response.data);
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadListDiarioOficial();
    }, []);

    const handleVoltar = () => {
        setLayoutDiarioOficial_id(null);
        setCadastro(false);
        loadListDiarioOficial();
    }

    if (layoutDiarioOficial_id || cadastro) {
        return <CadastroLayoutDiarioOficial
            id={layoutDiarioOficial_id}
            handleVoltar={handleVoltar}
        />
    }

    return <>
        <div className='d-flex align-items-center justify-content-between mb-4'>
            <h4 className='text-secondary m-0'>Layout diário oficial</h4>
            <Button color='success' onClick={() => { setCadastro(true) }}>+ Cadastrar</Button>
        </div >
        <Row className='mt-3'>
            <TabelaListagem
                actions={actions}
                title={"Lista de layout diário oficial"}
                options={{ print: false, search: true, pagination: true }}
                headers={headers}
                items={listDiarioOficial}
            />
        </Row>
    </>;
}

export default LayoutDiarioOficial;